module.exports = __webpack_public_path__ + "static/img/sm3.7b2059a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm3.jpg
// module id = FG2T
// module chunks = 1